<template>
  <!-- 全局提示框 -->
  <div class="dialog-tips dialog-center" v-show="visible">
    <div>{{message}}</div>
  </div>

</template>
<script>
  export default {
    data() {
      return {
        visible: false,
        message: ""
      };
    }
  };
</script>
<style scoped>
  .dialog-tips {
    position: fixed;
    z-index: 10000;
    min-width: 2.2rem;
    padding: 40px 22px;
    white-space: nowrap;
    background-color: #fff;
    border-radius: 10px;
    box-shadow: 0px 8px 15px 0 rgba(0, 0, 0, 0.1);
    text-align: center;
  }

  .dialog-tips-icon {
    width: 54px;
    height: 54px;
    display: inline-block;
    margin-bottom: 13px;
  }

  .dialog-center {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%)
  }

</style>



// WEBPACK FOOTER //
// src/components/common/toast.vue